import CommonStore from "../common_store";
import { action, makeObservable, observable, runInAction } from "mobx";
import api from "../../../api";
import { DatePickerProps, message, Modal, UploadFile } from "antd";
import { RangePickerProps } from "antd/es/date-picker";
import dictionary from "../../../utils/dictionary";
import axios from "axios";

class TemplateManageStore {
  commonStore?: CommonStore;

  constructor(baseStore?: CommonStore) {
    this.commonStore = baseStore;
    makeObservable(this);
  }
  @observable searchForm: any = {};
  @observable tableData: any = {};
  //表格加载状态
  @observable tableLoad: boolean = true;
  //分页信息
  @observable pageData: IPageData = {
    page: 1,
    size: 10,
    changePage: (page: number, size: number) => {
      runInAction(() => {
        this.pageData.page = page;
        this.pageData.size = size;
        this.pageData = { ...this.pageData };
      });
      this.getTemplatePage();
    },
  };

  @observable addOrUpdateForm: any = {};
  @observable modalLoading: boolean = false;
  @observable templateParamFileName: string = ""; //模板变量承诺文件名
  @observable socialCreditCertificateObjectNames: any = []; //统一社会信用代码证书文件名
  @observable socialCreditCertificateObjectNamesObj: any = []; //统一社会信用代码证书文件列表文件名
  @observable orderVoucherObjectNames: any = []; //隐私号订购凭证文件名
  @observable orderVoucherObjectNamesObj: any = []; //隐私号订购凭证文件列表文件名
  @observable signAuthzCertificateObjectNames: any = []; //签名授权凭证文件名
  @observable signAuthzCertificateObjectNamesObj: any = []; //签名授权凭证文件列表文件名
  @observable templateParamFileNameUrl: string = ""; //模板变量承诺文件地址
  @observable socialCreditCertificateObjectNamesUrl: any = []; //统一社会信用代码证书文件地址
  @observable orderVoucherObjectNamesUrl: any = []; //隐私号订购凭证文件地址
  @observable signAuthzCertificateObjectNamesUrl: any = []; //签名授权凭证文件地址
  @observable getAllEnumList: any = [];
  // @observable newTemplateSignature: boolean = false;
  @observable isWriteTemplateSignature: any = false;

  //上传图片文件地址
  @observable uploadImgUrl: any = {};

  //新增和编辑
  @observable addOrUpdateModal: any = {
    add: false,
    update: false,
    updateModalType: (type: "add" | "update") => {},
    get isOpen(): boolean {
      return this.add || this.update;
    },
    open: async (type: "add" | "update", data: any) => {
      if (type === "add") {
        runInAction(() => {
          this.addOrUpdateForm = {
            calledOperator: "ALL",
            isTemplateParamInfo: false,
          };
          this.addOrUpdateModal.add = true;
          this.addOrUpdateModal.update = false;
        });
      } else if (type === "update") {
        // runInAction(async () => {
        //   this.addOrUpdateModal.add = false;
        //   await this.getFileUrl(data)
        //     .then(() => {
        //       runInAction(() => {
        //         this.addOrUpdateModal.update = true;
        //         data.isTemplateParamInfo = data.templateParamInfo && data.templateParamInfo.length >0 ? true : false ;
        //         this.templateParamFileName = data.templateParamFileName;
        //         this.socialCreditCertificateObjectNamesObj =
        //           data.socialCreditCertificateObjectNames;
        //         this.orderVoucherObjectNamesObj = data.orderVoucherObjectNames;
        //         this.signAuthzCertificateObjectNamesObj =
        //           data.signAuthzCertificateObjectNames;
        //         this.newTemplateSignature = data.templateSignature ? true : false;
        //         this.addOrUpdateForm = { ...data };
        //         console.log(this.addOrUpdateForm);
        //       });
        //     })
        //     .catch((e: any) => {});
        // });
        await this.getFileUrl(data)
          .then(() => {
            runInAction(() => {
              this.addOrUpdateModal.add = false;
              this.addOrUpdateModal.update = true;
              data.isTemplateParamInfo =
                data.templateParamInfo && data.templateParamInfo.length > 0
                  ? true
                  : false;
              this.templateParamFileName = data.templateParamFileName;
              this.socialCreditCertificateObjectNamesObj =
                data.socialCreditCertificateObjectNames;
              this.orderVoucherObjectNamesObj = data.orderVoucherObjectNames;
              this.signAuthzCertificateObjectNamesObj =
                data.signAuthzCertificateObjectNames;
              // this.newTemplateSignature = data.templateSignature
              //   ? true
              //   : false;
              this.addOrUpdateForm = { ...data };
              console.log(this.addOrUpdateForm);
            });
          })
          .catch((e: any) => {});
      }
    },
    close: () => {
      runInAction(() => {
        this.addOrUpdateModal.add = false;
        this.addOrUpdateModal.update = false;
        this.addOrUpdateForm = {};
        this.isWriteTemplateSignature = false;
      });
      this.clearImg();
    },
  };

  //编辑新增
  setAddOrUpdateForm(obj: any) {
    runInAction(() => {
      this.addOrUpdateForm = obj;
      this.addOrUpdateForm.templateDemo = `【${
        this.addOrUpdateForm.templateSignatureNo
          ? this.getAllEnumList.find(
              (item: any) =>
                item.no === this.addOrUpdateForm.templateSignatureNo
            )?.templateSignature
          : this.addOrUpdateForm.templateSignature
          ? this.addOrUpdateForm.templateSignature
          : "xxx"
      }】${
        this.addOrUpdateForm.templateInfo
          ? this.addOrUpdateForm.templateInfo
          : "xxxxxxxxxx"
      }`;
    });
  }

  setSearchForm(obj: any) {
    runInAction(() => {
      this.searchForm = obj;
    });
  }

  //重置分页
  resetPage() {
    runInAction(() => {
      this.pageData.page = 1;
    });
  }

  //分页查询
  @action
  getTemplatePage() {
    this.commonStore?.getPagePermission("calling_card_template_management");
    this.getAllEnum();
    runInAction(() => {
      this.tableData = {};
      this.tableLoad = true;
    });
    const data = { ...this.searchForm };
    data.size = this.pageData.size;
    data.page = this.pageData.page;
    api.templateApi
      .getTemplatePage(data)
      .then((res: any) => {
        if (res.code == 200) {
          runInAction(() => {
            this.tableData = res.data;
            this.tableData = { ...this.tableData };
            this.tableLoad = false;
          });
        }
      })
      .catch((e: any) => {
        runInAction(() => {
          this.tableLoad = false;
        });
      });
  }

  // //选择填写新签名
  // @action
  // changeTemplateSignature() {
  //   runInAction(() => {
  //     this.newTemplateSignature = !this.newTemplateSignature;
  //   });
  // }

  @action
  templateDelete(no: string) {
    api.templateApi
      .templateDelete(no)
      .then((res: any) => {
        message.success("删除成功");
        this.resetPage();
        this.getTemplatePage();
      })
      .catch((e: any) => {});
  }

  //删除
  deletePower(no: string) {
    return new Promise((resolve, reject) => {
      Modal.confirm({
        centered: true,
        title: "确认删除",
        content: "您确定要删除该模版吗？",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          this.templateDelete(no);
          return resolve(true);
        },
        onCancel: () => {
          return false;
        },
      });
    });
  }

  @action
  getAllEnum() {
    api.signatureApi
      .getAllEnum()
      .then((res: any) => {
        runInAction(() => {
          this.getAllEnumList = res.data;
        });
      })
      .catch((e: any) => {});
  }

  //获取临时上传地址
  @action
  temporaryUpload(type: string, file: any, newFileList?: any, store?: any) {
    api.templateApi
      .temporaryUpload(file.name)
      .then(async (res: any) => {
        if (type === "templateParamFileName") {
          runInAction(() => {
            this.templateParamFileName = res.data.objectName;
          });
          newFileList[newFileList.length - 1].name = this.templateParamFileName;
          store.setFileList(newFileList, file);
        } else if (type === "socialCreditCertificateObjectNames") {
          runInAction(() => {
            this.socialCreditCertificateObjectNames = res.data.objectName;
          });
          newFileList[newFileList.length - 1].name =
            this.socialCreditCertificateObjectNames;
          store.setFileList(newFileList, file);
        } else if (type === "orderVoucherObjectNames") {
          runInAction(() => {
            this.orderVoucherObjectNames = res.data.objectName;
          });
          newFileList[newFileList.length - 1].name =
            this.orderVoucherObjectNames;
          store.setFileList(newFileList, file);
          console.log(this.orderVoucherObjectNamesObj);
        } else if (type === "signAuthzCertificateObjectNames") {
          runInAction(() => {
            this.signAuthzCertificateObjectNames = res.data.objectName;
          });
          newFileList[newFileList.length - 1].name =
            this.signAuthzCertificateObjectNames;
          store.setFileList(newFileList, file);
        }
        await this.uploadFile(file, res.data.urlPath);
      })
      .catch((err: any) => {});
  }

  //上传到临时地址
  uploadFile(file: any, url: any) {
    axios
      .put(url, file, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: false,
      })
      .then((response) => {})
      .catch((err) => {});
  }

  //获取临时下载地址,
  @action
  async getFileUrl(data: any) {
    if (data.templateParamFileName) {
      await api.templateApi
        .temporaryDown(data.templateParamFileName) //变量承诺函
        .then((res: any) => {
          runInAction(() => {
            this.templateParamFileNameUrl = res.data;
          });
        })
        .catch((err: any) => {});
    }
    if (data.socialCreditCertificateObjectNames) {
      data.socialCreditCertificateObjectNames.map(async (item: any) => {
        await api.templateApi
          .temporaryDown(item) //统一社会信用代码证书
          .then((res: any) => {
            runInAction(() => {
              this.socialCreditCertificateObjectNamesUrl.push({
                url: res.data,
                fileName: item,
              });
            });
          })
          .catch((err: any) => {});
      });
    }

    if (data.orderVoucherObjectNames) {
      data.orderVoucherObjectNames.map(async (item: any) => {
        await api.templateApi
          .temporaryDown(item) //隐私订购凭证
          .then((res: any) => {
            runInAction(() => {
              this.orderVoucherObjectNamesUrl.push({
                url: res.data,
                fileName: item,
              });
            });
          })
          .catch((err: any) => {});
      });
    }
    if (data.signAuthzCertificateObjectNames) {
      data.signAuthzCertificateObjectNames.map(async (item: any) => {
        await api.templateApi
          .temporaryDown(item) //签名授权凭证
          .then((res: any) => {
            runInAction(() => {
              this.signAuthzCertificateObjectNamesUrl.push({
                url: res.data,
                fileName: item,
              });
            });
          })
          .catch((err: any) => {});
      });
    }
  }

  //模板添加
  @action
  templateAdd() {
    runInAction(() => {
      this.addOrUpdateForm.templateParamInfo = this.addOrUpdateForm
        .isTemplateParamInfo
        ? this.addOrUpdateForm.templateParamInfo
        : [];
      this.addOrUpdateForm.templateSignatureNo =
        this.addOrUpdateForm.templateSignatureNo === "default"
          ? null
          : this.addOrUpdateForm.templateSignatureNo;
      this.addOrUpdateForm.templateParamFileName = this.templateParamFileName;
      this.addOrUpdateForm.socialCreditCertificateObjectNames =
        this.socialCreditCertificateObjectNamesObj;
      this.addOrUpdateForm.orderVoucherObjectNames =
        this.orderVoucherObjectNamesObj;
      this.addOrUpdateForm.signAuthzCertificateObjectNames =
        this.signAuthzCertificateObjectNamesObj;
      // this.addOrUpdateForm.templateDemo = `【${this.getAllEnumList.find((item: any) =>item.no === this.addOrUpdateForm.templateSignatureNo)?.templateSignature}】${this.addOrUpdateForm.templateInfo}`
      // this.addOrUpdateForm.templateDemo =`【
      //         ${this.addOrUpdateForm.templateSignatureNo
      //           ? this.getAllEnumList.find(
      //               (item: any) =>
      //                 item.no ===
      //                 this.addOrUpdateForm.templateSignatureNo
      //             )?.templateSignature
      //           : this.addOrUpdateForm.templateSignature
      //           ? this.addOrUpdateForm.templateSignature
      //           : "xxx"}
      //         】
      //         ${this.addOrUpdateForm.templateInfo
      //           ? this.addOrUpdateForm.templateInfo
      //           : "xxxxxxxxxx"}`
    });
    console.log(this.addOrUpdateForm);
    api.templateApi
      .templateAdd(this.addOrUpdateForm)
      .then((res: any) => {
        this.getTemplatePage();
        message.success("新增成功");
        this.addOrUpdateModal.close();
      })
      .catch((e: any) => {});
  }

  //清空图片
  @action
  clearImg() {
    runInAction(() => {
      this.templateParamFileName = "";
      this.socialCreditCertificateObjectNames = "";
      this.socialCreditCertificateObjectNamesObj = [];
      this.orderVoucherObjectNames = "";
      this.orderVoucherObjectNamesObj = [];
      this.signAuthzCertificateObjectNames = "";
      this.signAuthzCertificateObjectNamesObj = [];
      this.templateParamFileNameUrl = "";
      this.socialCreditCertificateObjectNamesUrl = [];
      this.orderVoucherObjectNamesUrl = [];
      this.signAuthzCertificateObjectNamesUrl = [];
    });
  }

  //模板修改
  @action
  templateUpdate() {
    runInAction(() => {
      this.addOrUpdateForm.templateParamInfo = this.addOrUpdateForm
        .isTemplateParamInfo
        ? this.addOrUpdateForm.templateParamInfo
        : [];
      this.addOrUpdateForm.templateNoId = this.addOrUpdateForm.no;
      this.addOrUpdateForm.templateParamFileName = this.templateParamFileName;
      this.addOrUpdateForm.socialCreditCertificateObjectNames =
        this.socialCreditCertificateObjectNamesObj;
      this.addOrUpdateForm.orderVoucherObjectNames =
        this.orderVoucherObjectNamesObj;
      this.addOrUpdateForm.signAuthzCertificateObjectNames =
        this.signAuthzCertificateObjectNamesObj;
      // this.addOrUpdateForm.templateDemo = `【${this.getAllEnumList.find(
      //   (item: any) =>item.no === this.addOrUpdateForm.templateSignatureNo
      // )?.templateSignature}】${this.addOrUpdateForm.templateInfo}`
    });
    console.log(this.addOrUpdateForm);

    api.templateApi
      .templateUpdate(this.addOrUpdateForm)
      .then((res: any) => {
        this.getTemplatePage();
        message.success("修改成功");
        this.addOrUpdateModal.close();
      })
      .catch((e: any) => {});
  }

  //启用
  @action
  templateStart(no: any) {
    api.templateApi
      .templateStart(no)
      .then((res: any) => {
        message.success("启用成功");
        this.getTemplatePage();
      })
      .catch((e: any) => {});
  }
  @action toTemplateStart(no: any) {
    return new Promise((resolve, reject) => {
      Modal.confirm({
        centered: true,
        title: "确认启用",
        content: "你是否要启用该模版？",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          this.templateStart(no);
          return resolve(true);
        },
        onCancel: () => {
          return false;
        },
      });
    });
  }

  //禁用
  @action
  templateForbidden(no: any) {
    api.templateApi
      .templateForbidden(no)
      .then((res: any) => {
        message.success("禁用成功");
        this.getTemplatePage();
      })
      .catch((e: any) => {});
  }
  @action toTemplateForbidden(no: any) {
    return new Promise((resolve, reject) => {
      Modal.confirm({
        centered: true,
        title: "确认禁用",
        content: "请注意：禁用后，该模板不可重新启用。",
        cancelText: "继续禁用",
        okText: "操作取消",
        onOk: () => {
          return false;
        },
        onCancel: () => {
          this.templateForbidden(no);
          return resolve(true);
        },
      });
    });
  }

  //清空图片地址
  @action
  clearImageUrl() {
    runInAction(() => {
      this.socialCreditCertificateObjectNamesUrl = [];
      this.orderVoucherObjectNamesUrl = [];
      this.signAuthzCertificateObjectNamesUrl = [];
    });
  }

  //清空图片名称
  @action
  clearImageObj() {
    runInAction(() => {
      this.socialCreditCertificateObjectNamesObj = [];
      this.orderVoucherObjectNamesObj = [];
      this.signAuthzCertificateObjectNamesObj = [];
    });
  }

  //获取一条数据
  @action
  templateGetOne(templateSignatureNo: string) {
    this.clearImageUrl();
    api.templateApi
      .templateGetOne(templateSignatureNo)
      .then(async (res: any) => {
        if (res.code == 200) {
          await this.getFileUrl(res.data);
        }
      })
      .catch((e) => {});
  }

  @action
  isTemplateSignature() {
    runInAction(() => {
      this.isWriteTemplateSignature = !this.isWriteTemplateSignature;
    });
    if (this.isWriteTemplateSignature) {
      runInAction(() => {
        this.addOrUpdateForm.templateSignature = "";
      });
      this.clearImageUrl();
    } else {
      if (this.addOrUpdateForm.templateSignatureNo) {
        this.templateGetOne(this.addOrUpdateForm.templateSignatureNo);
      }
    }
  }
}

export default TemplateManageStore;
